import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type TaggableModel from './taggable.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class TagModel extends Model {
  @attr declare name: string;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('taggable', {
    async: false,
    polymorphic: true,
    inverse: 'tags',
  })
  declare taggable: TaggableModel;

  [Type] = 'tag' as const;
}
